import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/products/singles/$id")({
	component: ProductLayout,
})

function ProductLayout() {
	return <Outlet />
}
